import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, NavigationEnd, RouterOutlet, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { Header } from '../../../components/shared/header/header';
import { AppointmentsService } from '../../../services/appointments.service';
import { LocalStorageUtil } from '../../../utils/local-storage.util';

@Component({
  selector: 'app-calendar-navigation',
  standalone: true,
  imports: [CommonModule, RouterOutlet, Header],
  templateUrl: './calendar-navigation.html',
  styleUrls: ['./calendar-navigation.scss']
})
export class CalendarNavigation implements OnInit, OnDestroy {
  currentPeriod: 'day' | 'week' | 'month' = 'day';
  appointmentsCount: number = 0;
  isLoading: boolean = false;

  private routerSubscription?: Subscription;
  private appointmentsSubscription?: Subscription;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private appointmentsService: AppointmentsService
  ) {}

  ngOnInit() {
    // Verificar rota inicial
    this.checkCurrentRoute();

    // Escutar mudanças de rota
    this.routerSubscription = this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe(() => {
        this.checkCurrentRoute();
      });
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    if (this.appointmentsSubscription) {
      this.appointmentsSubscription.unsubscribe();
    }
  }

  // Método para verificar a rota atual
  private checkCurrentRoute(): void {
    const url = this.router.url;

    if (url.includes('/calendar/day') || url.endsWith('/calendar')) {
      this.currentPeriod = 'day';
    } else if (url.includes('/calendar/week')) {
      this.currentPeriod = 'week';
    } else if (url.includes('/calendar/month')) {
      this.currentPeriod = 'month';
    }

    // Atualizar contador baseado no período
    this.loadAppointmentsCountFromApi();
  }

  selectPeriod(period: 'day' | 'week' | 'month') {
    this.currentPeriod = period;

    // Navegar para a rota correspondente
    const routes = {
      'day': '/calendar/day',
      'week': '/calendar/week',
      'month': '/calendar/month'
    };

    this.router.navigate([routes[period]]);
  }

  getTitle(): string {
    const titles = {
      'day': 'Agendamentos de Hoje',
      'week': 'Agendamentos da Semana',
      'month': 'Agendamentos do Mês'
    };
    return titles[this.currentPeriod] || 'Agendamentos';
  }

private loadAppointmentsCountFromApi() {
  this.isLoading = true;

  // Cancelar subscrição anterior se existir
  if (this.appointmentsSubscription) {
    this.appointmentsSubscription.unsubscribe();
  }

    const cd_dn = LocalStorageUtil.getSelectedVWDn(); // DN fixo conforme seu service
    const todayISO = this.appointmentsService.getTodayISO();

  switch (this.currentPeriod) {
    case 'day':
      this.appointmentsSubscription = this.appointmentsService
        .getAppointmentsDia(cd_dn, todayISO)
        .subscribe({
          next: (response) => {
            this.appointmentsCount = response.totalAgendamentos || 0;
            this.isLoading = false;
          },
          error: (error) => {
            console.error('Erro ao carregar contador do dia:', error);
            this.appointmentsCount = 0;
            this.isLoading = false;
          }
        });
      break;

    case 'week':
      this.appointmentsSubscription = this.appointmentsService
        .getAppointmentsSemana(cd_dn, todayISO)
        .subscribe({
          next: (response) => {
            this.appointmentsCount = response.totalAgendamentos || 0;
            this.isLoading = false;
          },
          error: (error) => {
            console.error('Erro ao carregar contador da semana:', error);
            this.appointmentsCount = 0;
            this.isLoading = false;
          }
        });
      break;

    case 'month':
      // Obter o mês e ano atual
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1;
      const currentYear = currentDate.getFullYear();

      this.appointmentsSubscription = this.appointmentsService
        .getAppointmentsMes(cd_dn, currentMonth, currentYear) // Passa mês e ano
        .subscribe({
          next: (response) => {
            this.appointmentsCount = response.totalAgendamentos || 0;
            this.isLoading = false;
          },
          error: (error) => {
            console.error('Erro ao carregar contador do mês:', error);
            this.appointmentsCount = 0;
            this.isLoading = false;
          }
        });
      break;
  }
}

  navigateToHome() {
    this.router.navigate(['/dashboard']);
  }
}
